import { ReactComponent as DisabledIcon } from '@elementary/common-ui/assets/16x16/disabled.svg';
import { ReactComponent as DeleteConnection } from '@elementary/common-ui/assets/minus-x-minus.svg';
import { ReactComponent as Logo } from '@elementary/common-ui/assets/logo.svg';
import { Dialog, FlexCenter, SvgIcon } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import { ActivityLogsIntegration } from 'shared/types';
import {
  getActivityLogsIntegrationIcon,
  getActivityLogsIntegrationLabel,
} from './activityLogsIntegrationUtils';

const IconsWrapper = styled(FlexCenter)`
  gap: 8px;
  height: 100%;
`;

const LogoWrapper = styled(FlexCenter)`
  width: 72px;
  height: 72px;
  border-radius: 12px;
  padding: 16px;
  background: ${({ theme }) => theme.palette.common.magenta};
`;

const PlatformIconWrapper = styled(FlexCenter)`
  border-radius: 12px;
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.palette.common.gray5};
  box-sizing: border-box;
`;

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (id: string) => void;
  loading?: boolean;
  selectedIntegration?: ActivityLogsIntegration;
};

const DeleteActivityLogsIntegrationDialog = ({
  open,
  onClose,
  selectedIntegration,
  onSubmit,
  loading,
}: Props) => {
  const label = selectedIntegration?.type
    ? getActivityLogsIntegrationLabel(selectedIntegration.type)
    : '';

  const icon = selectedIntegration?.type
    ? getActivityLogsIntegrationIcon(selectedIntegration.type)
    : getActivityLogsIntegrationIcon('datadog');

  return (
    <Dialog
      open={open}
      graphic={
        <IconsWrapper>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>

          <DeleteConnection />

          <PlatformIconWrapper>
            <SvgIcon width={40} height={40}>
              {icon}
            </SvgIcon>
          </PlatformIconWrapper>
        </IconsWrapper>
      }
      titleIcon={<DisabledIcon />}
      title={'Delete connection'}
      message={
        <Typography>
          Are you sure you want to delete your{' '}
          <Typography component="span" sx={{ mi: 0.5, fontWeight: 'bold' }}>
            {label}
          </Typography>{' '}
          connection?
        </Typography>
      }
      secondaryMessage={`This action is irreversible.`}
      onClose={onClose}
      onConfirmButtonClick={() =>
        selectedIntegration && onSubmit(selectedIntegration.id)
      }
      isLoading={!!loading}
      confirmText={loading ? 'Deleting' : 'Delete connection'}
      variant="error"
    />
  );
};

export default DeleteActivityLogsIntegrationDialog;
